import React from 'react';
import styles from './ExpiredMessagePanel.module.scss';
import { useTranslation } from "react-i18next";

const ExpiredMessagePanel = () => {
  const { t } = useTranslation(["app"]);
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t("app:expired_page_heading")}</h1>
      <p className={styles.message}>
      {t("app:expired_page_para_1")}
      </p>
      <p className={styles.message}>
      {t("app:expired_page_para_2")}
      </p>
    </div>
    
  );
};

export default ExpiredMessagePanel;